import { Link } from 'react-router-dom';

/**
 * Privacy policy page. Plain-language stub written for an internal
 * school coffee-ordering app. Replace specifics (contact email, real
 * data-retention policy) once school admin reviews.
 */
export function Privacy() {
  return (
    <section className="mx-auto max-w-2xl px-6 py-10">
      <Link to="/" className="text-sm text-wca-gray-mid hover:text-wca-black">
        ← Home
      </Link>
      <h1 className="font-display text-3xl mt-4 mb-6">Privacy Policy</h1>

      <p className="text-sm text-wca-gray-mid mb-8">
        Last updated 2026-05-27. The Cracked Mug is operated by Wesleyan Christian Academy. This
        policy explains what data we collect when you use the ordering site and what we do with it.
      </p>

      <div className="space-y-6 text-sm leading-relaxed">
        <section>
          <h2 className="font-display text-xl mb-2">What we collect</h2>
          <ul className="list-disc pl-5 space-y-1 text-wca-gray-mid">
            <li>Your name, email address, and (if you signed in with Google) profile photo</li>
            <li>Your classroom / room number and any allergies you enter on your profile</li>
            <li>The orders you place — drinks, customizations, tips, totals, timestamps</li>
            <li>Menu items you mark as favorites</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-xl mb-2">How we use it</h2>
          <p className="text-wca-gray-mid">
            Solely to operate The Cracked Mug coffee shop — letting baristas prepare and deliver
            your order, letting you reorder past favorites, and giving school admins basic
            operational reports (drinks sold, common allergies to stock for, busiest hours). We
            don&apos;t sell data, share it with advertisers, or use it for anything beyond the shop.
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl mb-2">Where it&apos;s stored</h2>
          <p className="text-wca-gray-mid">
            Google Firebase (Firestore database and Firebase Authentication), hosted on Google Cloud
            servers in the United States. Order attachments and menu photos live in Firebase
            Storage. The connection between your browser and our servers is encrypted with TLS.
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl mb-2">Payments</h2>
          <p className="text-wca-gray-mid">
            Payments are processed by Square. We never see or store your card number — Square
            handles all card data directly. We keep only an order reference and the dollar total.
          </p>
        </section>

        <section>
          <h2 className="font-display text-xl mb-2">Your choices</h2>
          <ul className="list-disc pl-5 space-y-1 text-wca-gray-mid">
            <li>You can edit your name, room, and allergies any time on the Profile page.</li>
            <li>
              To delete your account and order history, email the school&apos;s IT or shop admin and
              we&apos;ll remove your record within 30 days.
            </li>
            <li>You can sign out from any page to clear your local session.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-display text-xl mb-2">Contact</h2>
          <p className="text-wca-gray-mid">
            Questions about this policy? Reach out to the school office at Wesleyan Christian
            Academy.
          </p>
        </section>
      </div>
    </section>
  );
}
